// src/components/LoadingPage.jsx
import '../styles/LoadingPage.css';
import logo from '../assets/aiotics.png'; // put your logo inside src/assets

export default function LoadingPage() {
  return (
    <div className="loading-page">
      <div className="animation-container">
        {/* Pipes & flow animation */}
        <svg className="pipes" viewBox="0 0 200 100">
          <rect x="10" y="40" width="180" height="20" rx="5" className="pipe" />
          <circle cx="30" cy="50" r="6" className="flow" />
          <circle cx="70" cy="50" r="6" className="flow" />
          <circle cx="110" cy="50" r="6" className="flow" />
          <circle cx="150" cy="50" r="6" className="flow" />
        </svg>

        {/* Rotating gear */}
        <div className="gear">
          <div className="gear-inner"></div>
        </div>

        {/* Logo */}
        <img src={logo} alt="Company Logo" className="loading-logo" />
      </div>
      <p className="loading-text">Connecting Industrial IoT...</p>
    </div>
  );
}
